import { TemplateOptionSettings } from "../../../../types/global.types";
import "./redirection.scss";

interface Props {
  settings: TemplateOptionSettings | undefined;
  displayOnly: boolean;
}

const RedirectionButton = ({ settings, displayOnly }: Props) => {
  const handleClick = () => {
    const url = settings?.layoutOptions?.redirectionPlacement.page.replace(
      "*",
      ""
    );
    window.open(url, "_blank");
  };

  const redirectionText =
    (settings?.layoutOptions as any)?.redirectionText || "";
  const hasRedirectionText = redirectionText.trim().length > 0;
  const buttonText =
    settings?.layoutOptions?.redirectionButtonText || "Show more offers";

  const buttonStyle = {
    backgroundColor:
      settings?.layoutOptions?.redirectionButtonBackground || "#000000",
    color: settings?.layoutOptions?.redirectionButtonTextColor || "#ffffff",
    borderRadius: `${settings?.layoutOptions?.redirectionButtonBorderRadius}px`,
    border: `1px solid ${
      settings?.layoutOptions?.redirectionButtonBorderColor || "#000000"
    }`,
  };

  if (!settings?.layoutOptions?.redirection || displayOnly) {
    return null;
  }

  // If there's redirection text, show full-width row with text and button
  if (hasRedirectionText) {
    return (
      <div
        className="swiper-load-more swiper-load-more--with-text"
        style={{
          backgroundColor:
            (settings?.layoutOptions as any)?.redirectionBackground ||
            "#000000",
          borderRadius: `${settings?.mainLayout.borderRadius}px`,
        }}
      >
        <div
          className="redirection-text"
          style={{
            color:
              (settings?.layoutOptions as any)?.redirectionTextColor ||
              "#ffffff",
          }}
        >
          {redirectionText}
        </div>
        <div
          className="button-load-more"
          onClick={handleClick}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleClick();
            }
          }}
          style={buttonStyle}
        >
          {buttonText}
        </div>
      </div>
    );
  }

  return (
    <div className="swiper-load-more">
      <div
        className="button-load-more"
        onClick={handleClick}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleClick();
          }
        }}
        style={buttonStyle}
      >
        {buttonText}
      </div>
    </div>
  );
};

export default RedirectionButton;
